"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchasedResourceDto = void 0;
// a resource intended to be purchased for a line item
class PurchasedResourceDto {
}
exports.PurchasedResourceDto = PurchasedResourceDto;
//# sourceMappingURL=purcased-resource.dto.js.map